import { useState } from "react"
import Cardsimple from "../../cards/Cardsimple"
import Topnavbar from "../../sections/Topnavbar"
import FichaTabs from "../ficha/FichaTabs"
import { Helmet, HelmetProvider } from "react-helmet-async"
import Leftnavbar from "../../sections/Leftnavbar"
import ScrollButtons from "../../ScrollButtons/ScrollButtons"
import { useParams } from "react-router-dom"
import Footerbar from "../../sections/Footerbar"

const Ficha = () => {    
    const { codigo } = useParams()
    const [titulo, setTitulo] = useState(codigo)
    return (
        <>
            {
                (titulo.length > 5) && (
                    <HelmetProvider>
                        <Helmet>
                            <title>{(titulo)}</title>
                        </Helmet>
                    </HelmetProvider>
                )
            }
            <Leftnavbar />
            <Topnavbar />
            <div className="content-wrapper">
                <div className="content-header">
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-lg-12">
                                <h1 className="m-0">{titulo}</h1>
                            </div>                            
                        </div>
                    </div>
                </div>
                <section className="content">
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-lg-12">
                                <Cardsimple
                                    header={
                                        <ul className="nav nav-pills">
                                            <li className="nav-item"><a className="nav-link active" href="#ficha-tecnica" data-toggle="tab">Ficha Técnica</a></li>
                                            <li className="nav-item"><a className="nav-link" href="#otm-sismac" data-toggle="tab">OTMs Sismac</a></li>
                                            <li className="nav-item"><a className="nav-link" href="#otm-pcoman" data-toggle="tab">OTMs Pcoman</a></li>
                                            {/*<li className="nav-item"><a className="nav-link" href="#repuestos" data-toggle="tab">Repuestos</a></li> */}
                                        </ul>
                                    } />
                                <FichaTabs setTitulo={setTitulo} />
                            </div>
                        </div>
                    </div>
                </section>
                <a id="back-to-top" href="#" className="btn btn-danger btn-lg back-to-top" role="button" style={{ display: "none" }}><i className="fas fa-chevron-up"></i></a>
            </div>
            <Footerbar />            
        </>
    )
}
export default Ficha